import { MultiChoiceFilter } from 'features/search/domain/SearchQuery';
import { MultiChoiceFacet } from 'features/search/domain/SearchResult';
import { useFilterLabel } from 'features/search/hooks/useFilterLabel';
import useValueTranslation from 'features/search/hooks/useValueTranslation';
import { setKeywordValue, removeKeywordValue } from 'features/search/store';
import { useAppDispatch } from 'store';
import { SearchFacetProps } from '../SearchFilter';
import CheckboxFilter from './CheckboxFilter';
import FilterCollapse from './FilterCollapse';

const SearchMultiValueOrFacet = ({ facet, activeFacet }: SearchFacetProps<MultiChoiceFacet, MultiChoiceFilter>) => {
  const dispatch = useAppDispatch();
  const label = useFilterLabel(facet.field);

  const translateValue = useValueTranslation(facet.field);
  const values = (activeFacet ? activeFacet.facet.values : facet.values).map((v) => ({ ...v, label: translateValue(v.value) }));

  const onSelectKeyword = (value: string, checked: boolean) => {
    if (checked) {
      dispatch(setKeywordValue({ facet: activeFacet ? activeFacet.facet : facet, value }));
    } else {
      dispatch(removeKeywordValue({ facet: activeFacet ? activeFacet.facet : facet, value }));
    }
  };

  return (
    <FilterCollapse hide={facet.values.length === 0 && !activeFacet} defaultExpanded={activeFacet ? true : false} label={label}>
      <CheckboxFilter values={values} isSelected={(value) => facet.selected.includes(value)} onSelect={onSelectKeyword} />
    </FilterCollapse>
  );
};

export default SearchMultiValueOrFacet;
